/*
 * @Author: liyxt
 * @Date: 2020-05-29 09:53:24
 * @LastEditors: bbqin
 * @LastEditTime: 2022-04-28 10:41:00
 * @Description: file content
 */ 
import { toast } from './toast';
import { getParentWindow, getTopWindow } from './window.js';

export default function handelExitPage(headers, flag, authorizeError) {
    if (headers) {
        if (headers.redirect === 'REDIRECT') {
            authorizeError && authorizeError();
            //SpecialTip(headers.redirectstatus, exitPage, headers.contentpath);
            if(typeof getTopWindow().SpecialTip === 'function'){
                getTopWindow().SpecialTip(headers.redirectstatus, exitPage, headers.contentpath);
            }
            return false;
        } else if (headers.authorize === 'FALSE') {
            authorizeError && authorizeError();
            toast({ 
                color: 'danger', 
                content: headers.authorizemsg ? decodeURIComponent(headers.authorizemsg) : '该请求未配置鉴权信息', 
            });
            return false;
        } else {
            return flag;
        }
    }
    /**
         * 退出页面 
         * */
    function exitPage(hrefString) {
        getTopWindow().location.href = hrefString;
    }

}

export { handelExitPage };